export class Gender {
    public static FEMALE = new Gender('FEMALE', 'Fêmea');
    public static MALE = new Gender('MALE', 'Macho');
    public static TWINS = new Gender('TWINS', 'Gêmeos');

    public constructor(
        public readonly name: string,
        public readonly label: string
    ) { }

    public static values(): Gender[] {
        return [
            Gender.FEMALE,
            Gender.MALE,
            Gender.TWINS
        ];
    }

    public static get(name: string): Gender {
        const gender = Gender.values().find(it => it.name === name);
        if(!gender) {
            throw new Error(`${name} is not a mapped gender.`);
        }
        return gender
    }
}
